module.exports = __webpack_public_path__ + "static/assets/dcc599d3fd8491fb060e3fe9008c12a2.jpg";